import React from 'react';

const dietSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🌱</div>
  <div class="splash-header">
    <h1>We take your goals seriously.</h1>
    <div class="quote">
      Most diets are unsustainable, complicated, and don’t take YOU into account. Welcome to something different.
    </div>
  </div>
</div>`;

const dietSplashElement = {
  visibleIf: `{diet} > 3`,
  name: 'diet-splash',
  type: 'html',
  html: dietSplashHtml,
};

const DietSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🛠️  Gathering insights to guide your journey
    </div>
  )
}


export {
  dietSplashElement,
  DietSplashHeader,
}